import * as actionType from '@lib/actions/SiteActionType';
import { Dispatch } from 'react-redux';
import { ActionCreator } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { IAlarm, IChannel, INativeNavigator, IRecipient, ISchedule, ISite, IStoreSiteState } from 'types';
import { isTemperaturInRange } from 'util/util';
import * as Api from './API';

export const editTemperatureNavigate: ActionCreator<actionType.IEditTemperatureNavigateAction> = (no: number) => ({
  payload: {
    no
  },
  type: actionType.SITE_EDIT_TEMPERATURE_NAVIGATE_ACTION
});

export const editThermostatNavigate: ActionCreator<actionType.IEditTemperatureNavigateAction> = (no: number) => ({
  payload: {
    no
  },
  type: actionType.SITE_EDIT_THERMOSTAT_NAVIGATE_ACTION
});

export const navigateToDashboard: ActionCreator<actionType.IDashboardNavigateAction> = () => ({
  payload: {},
  type: actionType.SITE_DASHBOARD_NAVIGATE_ACTION
});

export const editOutputNavigate: ActionCreator<actionType.IEditTemperatureNavigateAction> = (no: number) => ({
  payload: {
    no
  },
  type: actionType.SITE_EDIT_OUTPUT_NAVIGATE_ACTION
});


export const editSiteNavigate: ActionCreator<actionType.ISiteEditNavigateAction> = (id: string, name: string) => ({
  payload: {
    id, name
  },
  type: actionType.SITE_EDIT_NAVIGATE_ACTION
});

export const editInputNavigate: ActionCreator<actionType.IEditTemperatureNavigateAction> = (no: number) => ({
  payload: {
    no
  },
  type: actionType.SITE_EDIT_INPUT_NAVIGATE_ACTION
});


export const recipientTestStart: ActionCreator<actionType.IEmptyAction> = () => ({
  type: actionType.SITE_RECIPIENT_TEST_START
});

export const workingStart: ActionCreator<actionType.IEmptyAction> = () => ({
  type: actionType.WORKING_START
});

export const workingStop: ActionCreator<actionType.IEmptyAction> = () => ({
  type: actionType.WORKING_STOP
});

export const tokenSuccess: ActionCreator<actionType.ITokenAction> = (token: string) => ({
  payload: {
    token
  },
  type: actionType.PUSH_TOKEN_SUCCESS,
});



/**
 * Utility method to make a fetch call and check if response is a 440 due to dead session
 * @param dispatch 
 * @param url 
 * @param params 
 */
export async function fetchCallWithSessionCheck(dispatch: Dispatch<IStoreSiteState>, url: string, showSpinner: boolean, params: any): Promise<Response> {
  const options = { dimBackground: true };
  if (showSpinner) { SpinnerPlugin.activityStart("Chargement", options) };
  let response: any;
  try {
    response = await fetch(url, params);
  } catch {
    if (showSpinner) { SpinnerPlugin.activityStop() };
    return response;
  }
  try {
    if (showSpinner) { SpinnerPlugin.activityStop() };
    if (response.status === 440) {
      dispatch(workingStop());
      /* tslint:disable:no-empty */
      (navigator as INativeNavigator).notification.alert('Votre session est expirée', () => { }, 'Smart TX');
      dispatch({
        type: actionType.SITE_SESSION_EXPIRED
      });
    } else if (response.status === 503) {
      dispatch({
        type: actionType.SITE_TIME_OUT
      });
      /* tslint:disable:no-empty */
      (navigator as INativeNavigator).notification.alert('Temps de réponse dépassé', () => { }, 'Smart TX');
    }
  }
  /* tslint:disable:no-empty */
  catch (error) {
  };
  dispatch(workingStop());
  return response;
}


// Async SignIn Redux-Thunk action
export const asyncSiteSelectAction: ActionCreator<
  ThunkAction<Promise<actionType.ISiteSelectAction>, IStoreSiteState, void>
  > = (idDevice: string, name: string, forceNavigateToDashboard: boolean) => {
    return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.ISiteSelectAction> => {
      try {
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_DEVICES}/${idDevice}`,
          forceNavigateToDashboard, {
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_GET,
          });
        if (response.status === 200) {
          const data = await response.json();
          const site: ISite = { name };
          // Extract channels
          site.device = { id: idDevice, mac: data.mac, m1: data.m1, m2: data.m2, ip: data.ip, remoteAddress: data.remoteAddress };
          site.temps = [];
          site.inputs = [];
          site.outputs = [];
          site.power = [];
          let lastValueTime: number = 0;
          /* tslint:disable:prefer-for-of */
          for (let i = 0; i < data.channels.length; i++) {
            if (data.channels[i].lastValue !== undefined) {
              const d = new Date(data.channels[i].lastValue.t)
              if (lastValueTime < d.getTime()) {
                lastValueTime = d.getTime();
              }
            }
            if (data.channels[i].no === 1) {
              site.temps[0] = data.channels[i];
              if (data.channels[i].lastValue !== undefined) {
                site.temps[0].value = data.channels[i].lastValue.v;
              } else {
                site.temps[0].value = 0;
              }
            } else if (data.channels[i].no === 2) {
              site.temps[1] = data.channels[i];
              if (data.channels[i].lastValue !== undefined) {
                site.temps[1].value = data.channels[i].lastValue.v;
              } else {
                site.temps[1].value = 0;
              }
            } else if (data.channels[i].no === 7) {
              site.inputs[0] = data.channels[i];
              if (data.channels[i].lastValue !== undefined) {
                site.inputs[0].value = data.channels[i].lastValue.v;
              } else {
                site.inputs[0].value = 0;
              }
            } else if (data.channels[i].no === 8) {
              site.inputs[1] = data.channels[i];
              if (data.channels[i].lastValue !== undefined) {
                site.inputs[1].value = data.channels[i].lastValue.v;
              } else {
                site.inputs[1].value = 0;
              }
            } else if (data.channels[i].no === 9) {
              site.outputs[0] = data.channels[i];
              if (data.channels[i].lastValue !== undefined) {
                site.outputs[0].value = data.channels[i].lastValue.v;
              } else {
                site.outputs[0].value = 2;
              }
            } else if (data.channels[i].no === 10) {
              site.outputs[1] = data.channels[i];
              if (data.channels[i].lastValue !== undefined) {
                site.outputs[1].value = data.channels[i].lastValue.v;
              } else {
                site.outputs[1].value = 2;
              }
            } else if (data.channels[i].no === 5) {
              site.power[0] = data.channels[i];
              if (data.channels[i].lastValue !== undefined) {
                site.power[0].value = data.channels[i].lastValue.v;
              } else {
                site.power[0].value = 0;
              }
            }
            else if (data.channels[i].no === 6) {
              site.power[1] = data.channels[i];
              if (data.channels[i].lastValue !== undefined) {
                site.power[1].value = data.channels[i].lastValue.v;
              } else {
                site.power[1].value = 0;
              }
            }
          }
          // Check counter max on input
          for (const input of site.inputs) {
            input.counterMaxReached = (input.mode.toString() === '2' && input.total >= input.counterMax);
          }
          for (const temp of site.temps) {
            temp.inAlarm = (isTemperaturInRange(temp.value) && (temp.value >= temp.thresholdUp || temp.value <= temp.thresholdDown));
          }
          // Add recipents
          site.recipients = data.recipients;
          for (let i = 0; i < site.recipients!.length; i++) {
            // site.recipients![i].id = i;
            site.recipients![i].modified = false;
          }
          site.device.connected = data.connected;  // Math.round((((new Date()).getTime() - lastValueTime) / 1000 / 60)) <= 10;
          if (site.device.connected && Math.round((((new Date()).getTime() - lastValueTime) / 1000 / 60)) > 15) {
            site.device.connected = false;
          }

          site.thermostatSchedule = data.thermostatSchedule;

          site.device.connectionType = data.connectionType;
          site.lastValueTime = new Date(lastValueTime);
          // Add gsm status
          site.device.gsmStatus = data.gsm;
          return dispatch({
            payload: {
              forceNavigateToDashboard,
              site,
            },
            type: actionType.SITE_SELECT_ACTION
          });
        } else {
          return dispatch({
            type: actionType.SITE_SELECT_ACTION
          });
        }
      } catch (e) {
        return dispatch({
          payload: {
            forceNavigateToDashboard,
            site:
            {
              mac: 'mac',
              name: 'Home',
              notif: 1,
            },

          },
          type: actionType.SITE_SESSION_EXPIRED
        });
      }
    };
  };



export const asyncSyncSiteAction: ActionCreator<
  ThunkAction<Promise<actionType.ISiteSyncAction>, IStoreSiteState, void>
  > = (idDevice: string) => {
    return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.ISiteSyncAction> => {
      try {
        dispatch({
          type: actionType.SITE_SYNC_ACTION_START
        });
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_DEVICES}/${idDevice}/${Api.API_METHOD_SYNC}`,
          true, {
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_POST,
          });
        if (response.status === 200) {
          return dispatch({
            payload: { errorMessage: '' },
            type: actionType.SITE_SYNC_ACTION_FINISH
          });
        } else {
          try {
            const data = await response.json();
            return dispatch({
              payload: { errorMessage: data.message, },
              type: actionType.SITE_SYNC_ACTION_FINISH
            });
          } catch (e) {
            return dispatch({
              payload: { errorMessage: 'ERROR', },
              type: actionType.SITE_SYNC_ACTION_FINISH
            });
          }
        }
      } catch (e) {
        return dispatch({
          payload: { errorMessage: 'NETWORK', },
          type: actionType.SITE_SYNC_ACTION_FINISH
        });
      }
    };
  };



export const asyncSiteListAction: ActionCreator<
  ThunkAction<Promise<actionType.ISiteListAction>, IStoreSiteState, void>
  > = (idDevice: string) => {
    return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.ISiteListAction> => {
      try {
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_SITES}`,
          true, {
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_GET,
          });
        if (response.status === 200) {
          const data = await response.json();
          return dispatch({
            error: false,
            errorMessage: '',
            payload: {
              sites: data.sites
            },
            type: actionType.SITE_LIST_ACTION_FINISH
          });
        } else {
          return dispatch({
            error: true,
            errorMessage: '',
            payload: {
              sites: []
            },
            type: actionType.SITE_LIST_ACTION_FINISH
          });
        }
      } catch (e) {
        return dispatch({
          type: actionType.SITE_SESSION_EXPIRED
        });
      }
    };
  };


/**
 * Will ask the ADT for update itself
 * @param idDevice 
 */
export const asyncUpdateSiteAction: ActionCreator<
  ThunkAction<Promise<actionType.ISiteUpdateAction>, IStoreSiteState, void>
  > = (idDevice: string) => {
    return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.ISiteUpdateAction> => {
      try {
        dispatch({
          type: actionType.SITE_UPDATE_ACTION_START
        });
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_DEVICES}/${idDevice}/${Api.API_METHOD_UPDATE}`,
          true, {
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_POST,
          });

        if (response.status === 200) {
          return dispatch({
            type: actionType.SITE_UPDATE_ACTION_FINISH
          });
        } else {
          try {
            const data = await response.json();
            return dispatch({
              payload: { errorMessage: data.message, },
              type: actionType.SITE_UPDATE_ACTION_FINISH
            });
          } catch (e) {
            return dispatch({
              payload: { errorMessage: 'ERROR', },
              type: actionType.SITE_UPDATE_ACTION_FINISH
            });
          }
        }

      } catch (e) {
        return dispatch({
          type: actionType.SITE_SESSION_EXPIRED
        });
      }
    };
  };


// Async Output Redux-Thunk action
export const asyncOutputChangeStateAction: ActionCreator<
  ThunkAction<Promise<actionType.IOutputChangedAction>, IStoreSiteState, void>
  > = (idDevice: string, id: number, value: number) => {
    return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.IOutputChangedAction> => {
      dispatch({
        payload: { idOutput: id },
        type: actionType.SITE_OUTPUT_CHANGE_START,
      });
      try {
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_DEVICES}/${idDevice}/${Api.API_METHOD_CHANNEL}/${id}/v`,
          true, {
            body: JSON.stringify({ 'v': value }),
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_POST,
          });
        if (response.status === 200) {
          return dispatch({
            payload: { idOutput: id, errorMessage: '' },
            type: actionType.SITE_OUTPUT_CHANGED,
          });
        } else {
          try {
            const data = await response.json();
            return dispatch({
              payload: { idOutput: id, errorMessage: data.message, },
              type: actionType.SITE_OUTPUT_CHANGED
            });
          } catch (e) {
            return dispatch({
              payload: { idOutput: id, errorMessage: 'ERROR', },
              type: actionType.SITE_OUTPUT_CHANGED
            });
          }
        }
      }
      catch (e) {
        return dispatch({
          payload: { idOutput: id, errorMessage: 'NETWORK' },
          type: actionType.SITE_OUTPUT_CHANGED
        });
      }
    };
  };




/**
 * Aims to save channel (output, input, temp) changes
 * @param idDevice 
 * @param channel 
 */
export const asyncChannelSaveAction: ActionCreator<
  ThunkAction<Promise<actionType.IChannelSaveAction>, IStoreSiteState, void>
  > = (idDevice: string, name: string, channel: IChannel) => {
    return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.IChannelSaveAction> => {
      try {
        dispatch({
          type: actionType.SITE_SAVE_ACTION_START
        });
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_DEVICES}/${idDevice}/${Api.API_METHOD_CHANNEL}/${channel.no}`,
          true, {
            body: JSON.stringify(channel),
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_PUT,
          });
        if (response.status === 200) {
          // Refresh site data
          dispatch(asyncSiteSelectAction(idDevice, name, true));
          return dispatch({
            payload: { errorMessage: '', idChannel: channel.no },
            type: actionType.SITE_CHANNEL_SAVE,
          });
        } else {
          try {
            const data = await response.json();
            return dispatch({
              payload: { idChannel: channel.no, errorMessage: data.message, },
              type: actionType.SITE_CHANNEL_SAVE
            });
          } catch (e) {
            return dispatch({
              payload: { idChannel: channel.no, errorMessage: 'ERROR', },
              type: actionType.SITE_CHANNEL_SAVE
            });
          }
        }
      } catch (e) {
        return dispatch({
          payload: { idChannel: channel.no, errorMessage: 'NETWORK', },
          type: actionType.SITE_SESSION_EXPIRED
        });
      }
    };
  };

/**
 * Aims to save recipients changes
 * @param idDevice 
 * @param recipients 
 */
export const asyncRecipientsSaveAction: ActionCreator<
  ThunkAction<Promise<actionType.IRecipientsSaveAction>, IStoreSiteState, void>
  > = (idDevice: string, name: string, recipients: IRecipient[]) => {
    return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.IRecipientsSaveAction> => {
      try {
        dispatch({
          type: actionType.SITE_SAVE_ACTION_START
        });
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_DEVICES}/${idDevice}/${Api.API_METHOD_RECIPIENT}`,
          true, {
            body: JSON.stringify(recipients),
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_POST,
          });
        if (response.status === 200) {
          // Refresh site data
          dispatch(asyncSiteSelectAction(idDevice, name, true));
          return dispatch({
            payload: {},
            type: actionType.SITE_RECIPIENTS_SAVE,
          });
        } else {
          return dispatch({
            payload: {},
            type: actionType.SITE_RECIPIENTS_SAVE
          });
        }
      } catch (e) {
        return dispatch({
          payload: {},
          type: actionType.SITE_SESSION_EXPIRED
        });
      }
    };
  };



/**
 * Aims to save schedules changes
 * @param idDevice 
 * @param schedules 
 */
export const asyncScheduleSaveAction: ActionCreator<
  ThunkAction<Promise<actionType.ISchedulesSaveAction>, IStoreSiteState, void>
  > = (idDevice: string, name: string, schedules: ISchedule[]) => {
    return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.ISchedulesSaveAction> => {
      try {
        dispatch({
          type: actionType.SITE_SAVE_ACTION_START
        });
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_DEVICES}/${idDevice}/${Api.API_METHOD_SCHEDULE}`,
          true, {
            body: JSON.stringify(schedules),
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_POST,
          });
        if (response.status === 200) {
          // Refresh site data
          dispatch(asyncSiteSelectAction(idDevice, name, false));
          return dispatch({
            payload: {},
            type: actionType.SITE_SCHEDULES_SAVE,
          });
        } else {
          return dispatch({
            payload: {},
            type: actionType.SITE_SCHEDULES_SAVE
          });
        }
      } catch (e) {
        return dispatch({
          payload: {},
          type: actionType.SITE_SESSION_EXPIRED
        });
      }
    };
  };

/**
 * Aims to send test message to a recipient
 * @param idDevice 
 * @param recipients 
 */
export const asyncRecipientsTestAction: ActionCreator<
  ThunkAction<Promise<actionType.IRecipientsTestAction>, IStoreSiteState, void>
  > = (idDevice: string, recipient: IRecipient) => {
    return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.IRecipientsTestAction> => {
      try {
        dispatch(recipientTestStart());
        dispatch(workingStart());
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_DEVICES}/${idDevice}/${Api.API_METHOD_RECIPIENT}/${Api.API_METHOD_RECIPIENT_TEST}`,
          true, {
            body: JSON.stringify(recipient),
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_POST,
          });
        if (response.status === 200) {
          return dispatch({
            payload: { errorMessage: '' },
            type: actionType.SITE_RECIPIENT_TEST_FINISH,
          });
        } else {
          try {
            const data = await response.json();
            return dispatch({
              payload: { errorMessage: data.message },
              type: actionType.SITE_RECIPIENT_TEST_ERROR
            });
          } catch (e) {
            return dispatch({
              payload: { errorMessage: 'ERROR' },
              type: actionType.SITE_RECIPIENT_TEST_ERROR
            });
          }
        }
      } catch (e) {
        return dispatch({
          payload: { errorMessage: 'ERROR' },
          type: actionType.SITE_SESSION_EXPIRED
        });
      }
    };
  };


export const asyncDeleteSiteAction: ActionCreator<
  ThunkAction<Promise<actionType.ISiteDeleteAction>, IStoreSiteState, void>
  > = (idDevice: string) => {
    return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.ISiteDeleteAction> => {
      try {
        await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_SITES}/${idDevice}`,
          true, {
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_DELETE,
          });
        dispatch(asyncSiteListAction());
        return dispatch({
          type: actionType.SITE_DELETE_ACTION_FINISH
        });
      } catch (e) {
        return dispatch({
          type: actionType.SITE_SESSION_EXPIRED
        });
      }
    };
  };

export const asyncAddSiteAction: ActionCreator<
  ThunkAction<Promise<actionType.ISiteAddAction>, IStoreSiteState, void>
  > = (code: string, name: string) => {
    return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.ISiteAddAction> => {
      try {
        dispatch({
          type: actionType.SITE_ADD_ACTION_START
        });
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_SITES}`,
          true, {
            body: JSON.stringify({ code, name }),
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_POST,
          });

        if (response.status === 200) {
          dispatch(asyncSiteListAction());
          return dispatch({
            payload: { errorMessage: '' },
            type: actionType.SITE_ADD_ACTION_FINISH
          });
        } else {
          try {
            const data = await response.json();
            return dispatch({
              payload: { errorMessage: data.message },
              type: actionType.SITE_ADD_ACTION_FINISH
            });
          } catch (e) {
            return dispatch({
              payload: { errorMessage: 'ERROR' },
              type: actionType.SITE_ADD_ACTION_FINISH
            });
          }
        }
      } catch (e) {
        return dispatch({
          payload: { errorMessage: 'NETWORK' },
          type: actionType.SITE_ADD_ACTION_FINISH
        });
      }
    };
  };




export const asyncEditSiteAction: ActionCreator<
  ThunkAction<Promise<actionType.ISiteEditAction>, IStoreSiteState, void>
  > = (idDevice: string, name: string) => {
    return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.ISiteEditAction> => {
      try {
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_SITES}/${idDevice}`,
          true, {
            body: JSON.stringify({ name }),
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_PUT,
          });

        if (response.status === 200) {
          dispatch(asyncSiteListAction());
          return dispatch({
            payload: { errorMessage: '' },
            type: actionType.SITE_EDIT_ACTION_FINISH
          });
        } else {
          try {
            const data = await response.json();
            return dispatch({
              payload: { errorMessage: data.message },
              type: actionType.SITE_EDIT_ACTION_FINISH
            });
          } catch (e) {
            return dispatch({
              payload: { errorMessage: 'ERROR' },
              type: actionType.SITE_EDIT_ACTION_FINISH
            });
          }
        }
      } catch (e) {
        return dispatch({
          payload: { errorMessage: 'NETWORK' },
          type: actionType.SITE_EDIT_ACTION_FINISH
        });
      }
    };
  };


/**
 * Aims to retrieve last firmare version
 * @param idDevice 
 * @param recipients 
 */
export const asyncFirmwareVersionAction: ActionCreator<
  ThunkAction<Promise<actionType.IFirmwarVersionAction>, IStoreSiteState, void>
  > = (idDevice: string) => {
    return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.IFirmwarVersionAction> => {
      try {
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_FIRMWWARE}`,
          true, {
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_GET,
          });
        if (response.status === 200) {
          const data = await response.json();
          return dispatch({
            error: false,
            errorMessage: '',
            payload: {
              m1: data.m1,
              m2: data.m2
            },
            type: actionType.FIRMWARE_VERSION_ACTION_FINISH
          });
        } else {
          return dispatch({
            error: true,
            errorMessage: '',
            payload: {
              m1: '',
              m2: ''
            },
            type: actionType.FIRMWARE_VERSION_ACTION_FINISH
          });
        }
      } catch (e) {
        return dispatch({
          type: actionType.SITE_SESSION_EXPIRED
        });
      }
    };
  };



/**
 * Aims to retrieve log events
 * @param idDevice 
 * @param recipients 
 */
export const asyncLogEventsAction: ActionCreator<
  ThunkAction<Promise<actionType.ILogEventListAction>, IStoreSiteState, void>
  > = (idDevice: string) => {
    return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.ILogEventListAction> => {
      try {
        dispatch({
          type: actionType.SITE_START_SYNCINGACTION
        });
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_DEVICES}/${idDevice}/${Api.API_METHOD_LOG_EVENTS}`,
          true, {
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_GET,
          });
        if (response.status === 200) {
          const data = await response.json();
          let logEvents: any[] = [{
            "data": "",
            "event": "0",
            "level": "I",
            "time": 1531215210000
          },];
          logEvents = data;
          for (const event of logEvents) {
            event.t = new Date(event.t);
          }
          return dispatch({
            error: false,
            errorMessage: '',
            payload: {
              error: false,
              logEvent: logEvents,
            },
            type: actionType.LOGEVENT_LIST_ACTION_FINISH
          });
        } else {
          return dispatch({
            error: true,
            errorMessage: '',
            payload: {
              error: true,
              logEvent: [],

            },
            type: actionType.LOGEVENT_LIST_ACTION_FINISH
          });
        }
      } catch (e) {
        return dispatch({
          type: actionType.SITE_SESSION_EXPIRED
        });
      }
    };
  };


/**
 * Aims to retrieve alarms list
 * @param idDevice 
 * @param recipients 
 */
export const asyncAlarmListAction: ActionCreator<
  ThunkAction<Promise<actionType.IAlarmListAction>, IStoreSiteState, void>
  > = (idDevice: string) => {
    return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.IAlarmListAction> => {
      try {
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_DEVICES}/${idDevice}/${Api.API_METHOD_ALARMS}`,
          true, {
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_GET,
          });
        if (response.status === 200) {
          const data = await response.json();
          const alarms: IAlarm[] = [];
          for (let i = 0; i < data.length; i++) {
            let unit: string = '°C';
            if (data[i].channel && data[i].channel.no) {
              if (data[i].channel.no === 7 || data[i].channel.no === 8) {
                unit = data[i].channel.counterUnit;
              } else if (data[i].channel.no === 5 || data[i].channel.no === 6) {
                unit = '';
                data[i].v = '';
                data[i].channel.label = '';
              }

              alarms.push({
                _id: data[i]._id,
                label: data[i].channel.label,
                t: data[i].t,
                ty: data[i].ty,
                unit,
                v: data[i].v,
              });
            }
          }
          return dispatch({
            error: false,
            errorMessage: '',
            payload: {
              alarm: alarms,
            },
            type: actionType.ALARM_LIST_ACTION_FINISH
          });
        } else {
          return dispatch({
            error: true,
            errorMessage: '',
            payload: {
              alarm: []
            },
            type: actionType.ALARM_LIST_ACTION_FINISH
          });
        }
      } catch (e) {
        return dispatch({
          type: actionType.SITE_SESSION_EXPIRED
        });
      }
    };
  };


/**
 * Aims to retrieve log events
 * @param idDevice 
 * @param recipients 
 */
export const asyncUserListAction: ActionCreator<
  ThunkAction<Promise<actionType.IUserListAction>, IStoreSiteState, void>
  > = (idDevice: string) => {
    return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.IUserListAction> => {
      try {
        dispatch({
          type: actionType.SITE_START_SYNCINGACTION
        });
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_SITES}/${idDevice}/${Api.API_METHOD_USERS}`,
          true, {
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_GET,
          });
        if (response.status === 200) {
          const data = await response.json();
          for (const user of data) {
            user.lastConnection = new Date(user.lastConnection);
          }
          return dispatch({
            error: false,
            errorMessage: '',
            payload: {
              error: false,
              user: data,
            },
            type: actionType.USER_LIST_ACTION_FINISH
          });
        } else {
          return dispatch({
            error: true,
            errorMessage: '',
            payload: {
              error: true,
              user: [],

            },
            type: actionType.USER_LIST_ACTION_FINISH
          });
        }
      } catch (e) {
        return dispatch({
          type: actionType.SITE_SESSION_EXPIRED
        });
      }
    };
  };


export const asyncPushSubscribeAction: ActionCreator<
  ThunkAction<Promise<actionType.IPushAction>, IStoreSiteState, void>
  > = (token: string) => {
    return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.IPushAction> => {
      let locale: string = 'fr_FR';
      const userLang = (navigator.language || 'fr').substr(0, 2);
      if (userLang.toUpperCase() === "EN" || userLang.toUpperCase() === "US") {
        locale = 'en_US';
      }
      try {
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_PUSH_DEVICES}`,
          true, {
            body: JSON.stringify({ 'token': token, 'locale': locale }),
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_POST,
          });
        return dispatch({
          payload: {
            subscribed: (response.status === 200)
          },
          type: actionType.PUSH_SUBSCRIBE_FINISH
        });
      } catch (e) {
        return dispatch({
          payload: { subscribed: false },
          type: actionType.PUSH_SUBSCRIBE_FINISH
        });
      }
    };
  };


export const asyncPushUnsubscribeAction: ActionCreator<
  ThunkAction<Promise<actionType.IPushAction>, IStoreSiteState, void>
  > = (token: string, locale: string) => {
    return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.IPushAction> => {
      try {
        const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_PUSH_DEVICES}/${token}`,
          true, {
            credentials: Api.API_CREDENTIALS,
            headers: Api.API_HEADERS,
            method: Api.API_VERB_DELETE,
          });
        return dispatch({
          payload: { subscribed: !(response.status === 200) },
          type: actionType.PUSH_SUBSCRIBE_FINISH
        });
      } catch (e) {
        return dispatch({
          payload: { subscribed: true },
          type: actionType.PUSH_SUBSCRIBE_FINISH
        });
      }
    };
  };




/**
 * Aims to register device to Google Firebase
 * @param idDevice 
 * @param recipients 
 */
// export const asyncDeviceRegisterAction: ActionCreator<
//   ThunkAction<Promise<actionType.IDeviceRegisteredAction>, IStoreSiteState, void>
//   > = (token: string) => {
//     return async (dispatch: Dispatch<IStoreSiteState>): Promise<actionType.IDeviceRegisteredAction> => {
//       try {
//         const response = await fetchCallWithSessionCheck(dispatch, Api.API_BASE_URL + `${Api.API_METHOD_FIRMWWARE}`,
//           true, {
//             credentials: Api.API_CREDENTIALS,
//             headers: Api.API_HEADERS,
//             method: Api.API_VERB_GET,
//           });
//         if (response.status === 200) {
//           return dispatch({
//             payload: {
//               token
//             },
//             type: actionType.DEVICE_REGISTERED
//           });
//         } else {
//           return dispatch({
//             payload: {
//               token
//             },
//             type: actionType.DEVICE_REGISTERED
//           });
//         }
//       } catch (e) {
//         return dispatch({
//           payload: {
//             token
//           },
//           type: actionType.SITE_SESSION_EXPIRED
//         });
//       }
//     };
//   };




// WEBPACK FOOTER //
// ./src/actions/SiteAction.tsx